import { CardActions, Typography } from '@mui/material';
import { OneMedia } from '@prismamedia/one-components';
import clx from 'classnames';
import { EditableDraft } from 'components/EditableDraft';
import { EditableTypography } from 'components/EditableTypography';
import { EditorState } from 'draft-js';
import { PAID_ARTICLE } from 'pages/CampaignPage/CampaignEditPage/ContentPage/utils/useGetBlockItems';
import React, { FC } from 'react';
import { BlockItemFormat } from '../';
import { BlockItemType } from '../../../utils';
import { Menu } from './Menu';
import { useStyles } from './styles';

interface BlockItemContentProps {
  articleProps: Partial<BlockItemType>;
  format: BlockItemFormat;
  onDeleteBlock?: () => void;
  onEditField?: (field: string, value: string | OneMedia | EditorState) => void;
  onSetLeadIn?: () => void;
}
export const BlockItemContent: FC<BlockItemContentProps> = ({
  articleProps: {
    blockType,
    content,
    linkLabel,
    surTitle,
    title,
    url,
    urlInError,
    urlInErrorMessage,
    articleQualifiers,
  },
  format: blockItemFormat,
  onDeleteBlock,
  onEditField,
  onSetLeadIn,
}) => {
  const classes = useStyles({
    isEditing: Boolean(onEditField),
    blockItemFormat,
  });
  const articlePublicURL =
    (url && !url.startsWith('http') ? `https://${url}` : url) || '';

  const paidArticle = articleQualifiers?.some(
    ({ qualifier }) => qualifier.title === PAID_ARTICLE,
  );

  return (
    <div className={classes.wrapper}>
      {blockItemFormat === BlockItemFormat.CONDENSED && (
        <div className={classes.titleWrapper}>
          {paidArticle && <div className={classes.paidArticle}>★</div>}
          <Typography className={classes.title} gutterBottom variant="h5">
            {title}
          </Typography>
        </div>
      )}

      {blockItemFormat === BlockItemFormat.EXPANDED && (
        <>
          <EditableDraft
            content={surTitle}
            className={clx(classes.defaultDraftField, classes.surTitle)}
            onDraftChange={(value: EditorState) => {
              onEditField?.('surTitle', value);
            }}
            placeholder="Saisir un surtitre"
          />

          <EditableDraft
            className={clx(classes.defaultDraftField, classes.title)}
            content={title}
            onDraftChange={(value: EditorState) => {
              onEditField?.('title', value);
            }}
            placeholder="Saisir un titre principal"
          />

          <EditableDraft
            allowMultiline={true}
            className={clx(classes.defaultDraftField, classes.content)}
            content={content}
            onDraftChange={(value: EditorState) => {
              onEditField?.('content', value);
            }}
          />

          <EditableDraft
            className={clx(classes.defaultDraftField, classes.linkLabel)}
            content={linkLabel}
            onDraftChange={(value: EditorState) => {
              onEditField?.('linkLabel', value);
            }}
            placeholder="Saisir le libellé du lien"
          />
        </>
      )}

      {(blockItemFormat === BlockItemFormat.AUTO_PROMO ||
        blockItemFormat === BlockItemFormat.EXPANDED) && (
        <EditableTypography
          className={classes.link}
          color="primary"
          content={articlePublicURL}
          multiline
          error={urlInError}
          errorMessage={urlInErrorMessage}
          placeholder="Saisir une url"
          variant="subtitle2"
          onTextFieldChange={(value: string) => {
            onEditField?.('url', value);
          }}
        />
      )}

      <CardActions className={classes.actionsButton}>
        <Menu
          articlePublicURL={articlePublicURL}
          blockItemFormat={blockItemFormat}
          blockType={blockType}
          onSetLeadIn={onSetLeadIn}
          onDeleteBlock={onDeleteBlock}
        />
      </CardActions>
    </div>
  );
};
